import React from 'react'

const BlogCard = () => {
    const cardItems = [1, 2, 3, 4];
    return (
        <>
        {
            cardItems.map((item,id)=>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div className="_blog_card_wrap">
                        <img src={`assets/img/blog${item}.png`} alt="chobi" className="_blog_card_img" />
                        <div className="_blog_card_con">
                            <h6 className="_blog_card_subtitle">13 augest 2022</h6>
                            <h3 className="_blog_card_title">introducing seaport protocol</h3>
                            <p className="_blog_card_txt">It is a long established fact that a reader will be
                                distracted by the readable
                                content of a page when looking at its layout. </p>
                            <a href="#0" className="_blog_card_link">Read more</a>
                        </div>
                    </div>
                </div>
            )
        }
        </>
    )
}

export default BlogCard;